import login from './login';

export default {
  language: 'bg-BG',
  country: 'bg',
  name: 'Български',
  embeddedLocale: login,
};
